import { useState, useCallback } from 'react';

/**
 * Hook for managing modal windows
 * 
 * @returns {Object} - State and methods for managing modals
 */
const usePatientModals = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  const [actionType, setActionType] = useState('');
  const [isPreviewVisible, setIsPreviewVisible] = useState(false);

  // Show main modal
  const showModal = useCallback((message, type) => {
    setModalMessage(message);
    setActionType(type);
    setIsModalVisible(true);
  }, []);

  // Hide main modal
  const hideModal = useCallback(() => {
    setIsModalVisible(false);
  }, []);

  // Show preview modal
  const showPreview = useCallback(() => {
    setIsPreviewVisible(true);
  }, []);

  // Hide preview modal
  const hidePreview = useCallback(() => {
    setIsPreviewVisible(false);
  }, []);

  return {
    // Main modal
    isModalVisible,
    modalMessage,
    actionType,
    showModal,
    hideModal,
    
    // Preview modal
    isPreviewVisible,
    showPreview,
    hidePreview
  };
};

export default usePatientModals;
